import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Hanger } from '@app/models/hanger';
import { environment } from '@environments/environment';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class HangerService {
  constructor(private http: HttpClient) {}

  get(data: any) {
    return this.http.get<Hanger[]>(`${API}hangers?FollowId=${data.FollowId}`);
  }

  create(hanger: Hanger) {
    return this.http.post<Hanger>(`${API}hangers`, hanger);
  }

  update(id, hanger) {
    return this.http.put<Hanger>(`${API}hangers/${id}`, hanger);
  }

  delete(hangerId){
    return this.http.delete<Hanger>(`${API}hangers/${hangerId}`,);
  }
}
